<template>
	<div>
		<div v-title data-title="椒江区文化传承保护中心"></div>
		<router-view />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				List_1: [],
				List_2: [],
				List_3: [],
				List_4: [],
			};
		},
		mounted() {
			//默认加载token
			this.getToken();
		},
		methods: {
			getToken() {
				let t =
					"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZCI6MCwiQVBQSUQiOjIwMjAxMSwiVXNlcklkIjoiIiwiVXNlck5hbWUiOiIiLCJPcGVuaWQiOiIxMjMiLCJIZWFkaW1ndXJsIjoiIiwiQXV0aG9yaXR5S2V5IjowLCJBdXRob3JpdHlWYWx1ZSI6IkdVRVNUIiwiZXhwIjoxNjY5NDY0MDE3LCJpc3MiOiJoc25tcyIsIm5iZiI6MTYzNzkyNzAxN30.SLfpcDwuFBXoAcLMnzqvykxPPqy0YaTNZYoq325cYac";
				this.$api.setToken(t);
			},
		},
	};
</script>



<style>
</style>


// WEBPACK FOOTER //
// src/components/views/web/bwg/_layout/template.vue